import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 68,
	height: 43,
	viewBox: "0 0 68 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1 18L25.3692 42L67 1",
		stroke: "#44CC00",
		strokeOpacity: .5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16 12.6341L25.6 22L42 6",
		stroke: "#44CC00",
		strokeWidth: 5
	})]
});
export default SvgSuccess;
